import { has, isEmpty, first } from 'lodash';
export default function findFirstOption(options) {
  const firstOption = first(options);
  return has(firstOption, 'children') && !isEmpty(firstOption.children) ? first(firstOption.children) : firstOption;
}
//# sourceMappingURL=findFirstOption.js.map